module.exports = __webpack_public_path__ + "userprofiles.svg?cc713158ce141dbdb8f24735c9068743";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/userprofiles.svg
// module id = 118
// module chunks = 0